import { toastError } from '@components/Toast';

import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

// An order id gets the columns under that order's buyer names, where the buyer has its own name
// for a deliverable. The dashboard across all orders asks without one, since a single heading
// there stands over styles of many brands.
export const fetchOrderDashboardHeadings =
	(orderId = null) =>
	async (dispatch) => {
		await ApiClient.GET('getTaskMasterData', orderId ? `?orderId=${orderId}` : '')
			.then((response) => {
				dispatch({
					type: Types.STORE_ORDER_DASHBOARD_TABLE_HEADINGS,
					payload: response.data
				});
			})
			.catch((error) => {
				// A request that never reached the server has no response to read a message from,
				// and dereferencing it here threw inside the catch, which surfaced as an uncaught
				// runtime error rather than a toast.
				toastError(error?.response?.data?.message || 'Could not load the TNA task columns.');
			});
	};
